import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPluginUpdateGet = {
    path: "/plugin-update/:slug",
    method: RouteHttpVerb.GET
};
export { locationRestPluginUpdateGet };
